import type { IconBaseProps } from "./IconBase";
import IconBase from "./IconBase";

const UploadIcon = (props: IconBaseProps) => (
  <IconBase {...props}>
    <path fill="currentColor" d="M9 16h6v-6h4l-7-7-7 7h4v6zm-4 2h14v2H5v-2z" />
  </IconBase>
);

export default UploadIcon;
